export default "__VITE_ASSET__Ctj4Gfyk__"